import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { OffersCountResponse, ShiftTimeResponse } from '../../../../../api';
import { BaseAvatarSize } from '../../../../shared/components/avatar/base-avatar.component';
import { BaseButtonSize } from '../../../../shared/components/button/base-button.component';
import { BaseInquiryService } from '../../_services/base-inquiry.service';
import { BaseRolesService } from '../../../../core/services/base-roles.service';
import { BASE_PERMISSIONS } from '../../../../core/constants/base-permissions';
import { BaseInquiryType } from '../../_interfaces/base-inquiry.interface';

@Component({
  selector: 'base-inquiry-details-sidebar',
  templateUrl: './inquiry-details-sidebar.component.html',
})
export class InquiryDetailsSidebarComponent implements OnChanges, OnInit {
  @ViewChild('sidebarContent', { static: true }) sidebarContent: ElementRef;
  @Input() inquiry: BaseInquiryType | undefined;
  @Input() offersCount: OffersCountResponse | undefined;
  @Input() shiftTimes: (ShiftTimeResponse & { index: number; label?: string })[] = [];
  @Input() isSidebarVisible = false;
  @Input() widgetsTemplate: TemplateRef<any>;
  @Input() inquiryId: number | undefined;
  @Output() hideSidebar = new EventEmitter<void>();

  isPsp: boolean;
  canPreselectOffers: boolean;
  avatarSize = BaseAvatarSize;
  buttonSize = BaseButtonSize;

  constructor(
    private offcanvasService: NgbOffcanvas,
    private baseInquiryService: BaseInquiryService,
    private rolesService: BaseRolesService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.isSidebarVisible) {
      const isSidebarVisible = changes.isSidebarVisible?.currentValue;

      isSidebarVisible ? this.openInfoOffcanvas(this.sidebarContent) : this.offcanvasService.dismiss();
    }
  }

  ngOnInit() {
    this.isPsp = this.rolesService.isPsp();
    this.canPreselectOffers = this.rolesService.hasCustomerFeaturePermission(BASE_PERMISSIONS.FEATURE_PRESELECT_OFFERS);
  }

  private openInfoOffcanvas(content: any): void {
    this.offcanvasService
      .open(content, {
        ariaLabelledBy: 'offcanvas-basic-title',
        position: 'end',
        panelClass: 'right-content-offcanvas',
      })
      .result.then(
        () => {},
        () => {
          this.baseInquiryService.toggleInquirySidebarSubject$.next(false);
          this.hideSidebar.emit();
        }
      );
  }
}
